import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=82e55d56&"
import script from "./Notificaciones.vue?vue&type=script&lang=js&"
export * from "./Notificaciones.vue?vue&type=script&lang=js&"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Notificaciones.vue"
export default component.exports